<template>
  <div class="mb-6">

    <div class="columns is-multiline">
      <div class="column is-12-mobile is-2-tablet">
        <div class="field">
          <label class="label">Intervallo date</label>
          <InputDate v-model="filters.range" @update="onFilterInput" placeholder="Intervallo date" :range="true" :showIcon="true" />
        </div>
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Tipo manutenzione"
          v-model="filters.type"
          :options="$store.state.revision_types"
          id="name"
          track-by="name"
          label="name"
          @select="onFilterInput"
          @remove="onFilterInput"
        />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Rcee"
          v-model="filters.rceeType"
          :options="rceeTypes"
          id="value"
          track-by="value"
          label="key"
          @select="onFilterInput"
          @remove="onFilterInput"
        />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Occupante"
          v-model="filters.occupant"
          @select="filterOccupant"
          @remove="filterOccupant(false)"
          :options="clients"
          :loading="waitClients"
          :disabled="waitClients"
          id="_id"
          track-by="_id"
          :custom-label="$clientName"
        />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Proprietario"
          v-model="filters.client"
          @select="filterClient"
          @remove="filterClient(false)"
          :options="clients"
          :loading="waitClients"
          :disabled="waitClients"
          id="_id"
          track-by="_id"
          :custom-label="$clientName"
        />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Luogo" v-model="filters.place" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Impianto" v-model="filters.implant" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Note" v-model="filters.notes" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Appuntamento"
          v-model="filters.operation"
          @select="onFilterInput"
          :options="[{'label': 'Sì', value: true}, {'label': 'No', value: false}]"
          id="value"
          track-by="value"
          label="label"
        />
      </div>
      <div class="column is-12-mobile is-1-tablet">
        <label class="label">&nbsp;</label>
        <button class="button" @click="resetFilters()"><font-awesome-icon icon="filter-circle-xmark" />Reset</button>
      </div>
    </div>

    <!--<div class="columns is-multiline">
      <div class="column is-12-mobile is-4-tablet">
        <label class="label">&nbsp;</label>
        <div class="buttons">
          <button class="button is-info" @click="openSelected = true" :disabled="selected.length === 0">Modifica</button>
          <button class="button is-info" :class="{'is-loading': waitDocOffer}" @click="createDocOffer()" :disabled="selected.length === 0 || waitDocOffer">Genera doc offerta</button>
        </div>
      </div>
    </div>-->

    <div class="b-table has-pagination" :class="{'is-loading': loading}">
      <div class="table-wrapper has-mobile-cards">
        <table class="table is-fullwidth is-striped is-hoverable is-fullwidth">
          <thead>
          <tr>
            <!--<th style="width: 14px;"><label class="checkbox"><input type="checkbox" v-model="selectAllValue" @change="selectAll()" ></label></th>-->
            <th style="width: 100px">Scadenza</th>
            <th style="width: 150px">Tipo manutenzione</th>
            <th class="has-text-centered" style="width: 80px">Rcee</th>
            <th style="width: 350px"><div>Occupante</div><div><small class="has-text-grey is-abbr-like">Proprietario</small></div></th>
            <th style="width: 350px">Luogo</th>
            <th>Impianto</th>
            <th>Note</th>
            <th style="width: 100px">Storico</th>
            <th style="width: 80px"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(deadline, index) in deadlines" :key="index">
            <!--<td>
              <label class="checkbox">
                <input type="checkbox" v-model="deadline.selected">
              </label>
            </td>-->
            <td data-label="Data">
              {{new Date(deadline.expire).toDisplay()}}
            </td>
            <td data-label="Tipo manutenzione">
              {{deadline.type}}
            </td>
            <td data-label="Rcee">
              <div v-if="!parseInt(deadline.rcee?.next)" class="has-text-centered">
                <font-awesome-icon icon="fa-regular fa-circle-question" />
              </div>
              <div v-else-if="deadline.rcee?.required" class="has-text-success has-text-centered">
                <font-awesome-icon icon="fa-regular fa-circle-check" />
              </div>
              <div v-else-if="!deadline.rcee?.required" class="has-text-danger has-text-centered">
                <font-awesome-icon icon="fa-regular fa-circle-xmark" />
                <div v-if="deadline.rcee?.next && !deadline.rcee?.required"><small class="has-text-grey is-abbr-like" :title="deadline.rcee?.next">{{deadline.rcee?.next}}</small></div>
              </div>
            </td>
            <td data-label="Occupante">
              <router-link v-if="deadline.occupant" :to="'/clienti/' + deadline.occupant._id">
              <ClientHeading :client="deadline.occupant" />
            </router-link>
            <router-link v-if="deadline.client" :to="'/clienti/' + deadline.client._id">
              <ClientHeading :client="deadline.client" :owner="true" />
            </router-link>
            </td>
            <td data-label="Luogo">
              <router-link v-if="deadline.place_occupant" :to="'/luoghi/' + deadline.place_occupant._id">
                <AddressDisplay :value="deadline.place_occupant" />
              </router-link>
            </td>
            <td data-label="Impianto">
              <router-link v-if="deadline.system" :to="'/impianti/' + deadline.system._id" style="white-space: pre-line">
                <div>{{deadline.system.name}}</div>
                <div><small class="has-text-grey is-abbr-like" :title="deadline.system.type">{{deadline.system.type}}</small></div>
                <div class="tags" v-if="deadline.system.types.length">
                  <span class="tag is-dark" v-for="(type, index) in deadline.system.types" :key="index">{{ type }}</span>
                </div>
              </router-link>
            </td>
            <td data-label="Note">
              <div v-if="deadline.system" style="white-space: pre-line">
                {{ deadline.system.notes }}
              </div>
            </td>
            <td data-label="Storico">
              {{deadline.log?.length ? deadline.log.length : ''}}
            </td>
            <td class="is-actions-cell is-justify-content-flex-end">
              <div class="buttons is-right">
                <button v-if="!deadline.system.archived" class="button is-secondary" @click="archive(deadline.system, true)" title="Archivia" :class="[{'is-loading': deadline.system.waitArchive}]" :disabled="deadline.system.waitArchive">
                  <span class="icon"><font-awesome-icon icon="lock" /></span>
                </button>
                <button v-if="deadline.system.archived" class="button is-secondary" @click="archive(deadline.system, false)" title="Ripristina" :class="[{'is-loading': deadline.system.waitArchive}]" :disabled="deadline.system.waitArchive">
                  <span class="icon"><font-awesome-icon icon="lock-open" /></span>
                </button>
                <button v-if="!deadline.operation" class="button is-success" @click="openAppointment(deadline)">
                  <span class="icon"><font-awesome-icon icon="plus" /></span>
                </button>
                <router-link v-if="deadline.operation" :to="'/appuntamenti/' + deadline.operation._id" class="button is-primary has-tooltip-arrow has-tooltip-multiline" :data-tooltip="tooltipText(deadline.operation)" >
                  <span class="icon"><font-awesome-icon icon="file-lines" /></span>
                </router-link>
              </div>
            </td>
          </tr>
          <tr v-if="deadlines.length === 0">
            <td colspan="100" class="has-text-centered has-text-grey">
              <i>Nessun risultato</i>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <Pagination :pagination="pagination" @change="getDeadlines($event)" />
    </div>

    <!--<div class="modal" :class="{'is-active': openSelected}">
      <div class="modal-background" @click="openSelected = false"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Modifica scadenza</p>
          <button class="delete" aria-label="close" @click="openSelected = false"></button>
        </header>
        <section class="modal-card-body">
          <div class="field">
            <label class="label">Nuova scadenza</label>
            <div class="control">
              <input class="input" type="date" placeholder="Nuova scadenza" v-model="openSelectedNewDate" />
            </div>
          </div>
        </section>
        <footer class="modal-card-foot is-flex is-justify-content-end">
          <button class="button" @click="openSelected = false"><font-awesome-icon icon="times" />Chiudi</button>
          <button class="button is-primary" @click="changeSelected()" :class="[{'is-loading': waitSaveSelected}]" :disabled="waitSaveSelected"><font-awesome-icon icon="save" />Salva</button>
        </footer>
      </div>
    </div>-->

    <AppointmentCalendar :deadline="deadline" :open="openModalAppointment" @close="this.openModalAppointment = false" @saved="savedAppointment()" />

  </div>
</template>

<script>
import AddressDisplay from '../components/AddressDisplay.vue'

export default {
  components: {
    AddressDisplay
  },

  data() {
    return {
      filters: this.$store.state.filters.deadline,

      rceeTypes: [
      {
          key: 'Si',
          value: 'yes'
        },
        {
          key: 'No',
          value: 'no'
        },
        {
          key: 'Incompleto',
          value: 'incomplete'
        },
      ],

      deadlines: [],

      clients: [],
      cities: [],

      pagination:{
        total: false,
        selected: false
      },

      loading: true,
      waitClients: true,
      waitCities: true,

      openSelected: false,
      openSelectedNewDate: '',
      waitSaveSelected: false,

      openModalAppointment: false,
      deadline: {},

      waitDocOffer: false,

      //selectAllValue: false,
    }
  },

  /*computed: {
    selected() {
      const result = this.deadlines.filter(deadline => {
        if (deadline.selected) {
          return true
        }
      })
      return result
    }
  },*/

  methods: {
    filterOccupant(selected) {
      this.filters.occupant = selected
      this.getDeadlines()
    },

    filterClient(selected) {
      this.filters.client = selected
      this.getDeadlines()
    },

    resetFilters() {
      this.filters = {
        range: {start: new Date().getFirstDayMonth(), end: new Date().getLastDayMonth()}
      }

      this.getDeadlines()
    },

    getDeadlines(args = {page: 1, size: 30, scroll: 0}) {
      const self = this

      this.loading = true

      this.$store.commit('setFilter', {name: 'deadline', value: this.filters})
      this.$store.commit('setPage', {name: 'deadline', value: {number: args.page, size: args.size}})

      this.$http.get('/revision/deadline', { params: {
        page: args.page,
        size: args.size,
        startDate: this.filters.range.start.toDateInputValue(),
        endDate: this.filters.range.end.toDateInputValue(),
        type: this.filters.type ? this.filters.type.name : null,
        occupant: this.filters.occupant ? this.filters.occupant._id : null,
        client: this.filters.client ? this.filters.client._id : null,
        place: this.filters.place,
        implant: this.filters.implant,
        notes: this.filters.notes,
        operation: this.filters.operation ? this.filters.operation.value : null,
        rceeType: this.filters.rceeType ? this.filters.rceeType.value : null
      } }).then(response => {
        if (response && response.data) {
          this.deadlines = response.data.records
          this.pagination = {
            total: response.data.totalRecords,
            pages: response.data.totalPages,
            selected: response.data.currentPage
          }

          if (args.scroll) {
            self.$nextTick(() => {
              window.scroll(0, args.scroll)
            })
          }
        }

        this.loading = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.loading = false
      })
    },

    openAppointment(deadline) {
      this.deadline = deadline
      this.openModalAppointment = true
    },

    savedAppointment() {
      this.openModalAppointment = false

      this.getDeadlines()
    },

    archive(implant, value) {
      const self = this
      implant.waitArchive = true

      this.$http.put('/implant/' + implant._id, {archived: value})
      .then(function (response) {
        self.getDeadlines()
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        implant.waitArchive = false
      })
    },

    tooltipText(operation) {
      let result = "Appuntamento"

      if (operation.appointment_date) {
        result += " " + new Date(operation.appointment_date).toDisplay()
      }

      return result
    }

    /*changeSelected() {
      const self = this

      if (!self.openSelectedNewDate) {
        alert('Devi inserire una data!')
        return
      }

      this.waitSaveSelected = true

      let elements = []
      self.selected.forEach(element => {
        elements.push({
          kind: element.system.kind,
          id_system: element.system._id,
          id_revision: element._id
        })
      })

      this.$http.post('/revision/deadline/multiple-edit', { elements: elements, newDate: self.openSelectedNewDate }).then(response => {
        self.getDeadlines()

        self.openSelected = false
        self.waitSaveSelected = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.openSelected = false
        self.waitSaveSelected = false
      })
    },

    createDocOffer() {
      const self = this

      self.waitDocOffer = true

      let ids = []
      self.selected.forEach(element => {
        if (element.system && element.system.kind === 'lifting') {
          ids.push(element.system._id)
        }
      })

      this.$http.post('/revision/deadline/create-doc-offer', { ids: ids }).then(response => {
        const url = response.data.url
        window.location = url

        self.waitDocOffer = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.waitDocOffer = false
      })
    },

    selectAll() {
      this.deadlines.forEach(deadline => {
        deadline.selected = this.selectAllValue
      })
    }*/
  },

  mounted() {
    const self = this

    this.$http.get('/client/filter')
      .then(function (response) {
        self.clients = response.data
        self.waitClients = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })

    this.$http.get('/place/cities/filter')
      .then(function (response) {
        self.cities = response.data

        self.waitCities = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })

    self.getDeadlines({page: this.$store.state.pages.deadline.number, size: this.$store.state.pages.deadline.size, scroll: this.$store.state.pages.deadline.scroll})
  },

  created() {
    this.onFilterInput = this.$debounce(() => this.getDeadlines(), 500)
  },

  beforeUnmount() {
    const scroll = window.top.scrollY
    let page = Object.assign({}, this.$store.state.pages.deadline)
    page.scroll = scroll
    this.$store.commit('setPage', {name: 'deadline', value: page})
  }
}
</script>